import {useMemo} from "react";
import {matchPath, useLocation} from "react-router";

import {rpAppPath} from "@pg-mono/rp-routes";

import {IOfferListingParams} from "../types/OfferListingParams";

const OFFER_LISTING_MATCH_PATHS = [
    rpAppPath.friendlyOfferListAbroadCountryMap,
    rpAppPath.friendlyOfferListAbroadRegionMap,
    rpAppPath.offer.map,
    rpAppPath.friendlyOfferListMap.base,
    rpAppPath.friendlyOfferListMap.subType,
    rpAppPath.multiOfferList.map,
    rpAppPath.friendlyOfferListAbroadRegion,
    rpAppPath.friendlyOfferListAbroadCountry,
    rpAppPath.offer.list,
    rpAppPath.friendlyOfferList,
    rpAppPath.friendlyOfferListSubType,
    rpAppPath.friendlyOfferListSubFilterGeneral,
    rpAppPath.multiOfferList.base
];

export function useOfferListingParams(): Partial<IOfferListingParams> {
    const {pathname} = useLocation();

    return useMemo(() => {
        const match = matchPath(pathname, {
            path: [...OFFER_LISTING_MATCH_PATHS],
            exact: true
        });

        return (match?.params ?? {}) as Partial<IOfferListingParams>;
    }, [pathname]);
}
import {useMemo} from "react";
import {matchPath, useLocation} from "react-router";

import {rpAppPath} from "@pg-mono/rp-routes";

import {IOfferListingParams} from "../types/OfferListingParams";

const OFFER_LISTING_MATCH_PATHS = [
    rpAppPath.friendlyOfferListAbroadCountryMap,
    rpAppPath.friendlyOfferListAbroadRegionMap,
    rpAppPath.offer.map,
    rpAppPath.friendlyOfferListMap.base,
    rpAppPath.friendlyOfferListMap.subType,
    rpAppPath.multiOfferList.map,
    rpAppPath.friendlyOfferListAbroadRegion,
    rpAppPath.friendlyOfferListAbroadCountry,
    rpAppPath.offer.list,
    rpAppPath.friendlyOfferList,
    rpAppPath.friendlyOfferListSubType,
    rpAppPath.friendlyOfferListSubFilterGeneral,
    rpAppPath.multiOfferList.base
];

export function useOfferListingParams(): Partial<IOfferListingParams> {
    const {pathname} = useLocation();

    return useMemo(() => {
        const match = matchPath(pathname, {
            path: [...OFFER_LISTING_MATCH_PATHS],
            exact: true
        });

        return (match?.params ?? {}) as Partial<IOfferListingParams>;
    }, [pathname]);
}
